// extracted by mini-css-extract-plugin
export default {"excelBtn":"ClientsDiscount_excelBtn__fH4lL","list":"ClientsDiscount_list__Tz8hz","listHeader":"ClientsDiscount_listHeader__fTJLY","pagination":"ClientsDiscount_pagination__h4OGB"};